//sticky atc
function changeActive(selected){
    let stickyLabels = document.getElementsByClassName('sticky-atc__label')
    let labelFor = selected.getAttribute('data-for')
    for (let a = 0; a < stickyLabels.length; a++ ){
        stickyLabels[a].classList.remove('selected')
    }
    selected.classList.add('selected');
    document.querySelector('#' + labelFor).click();
    try{ 
      setTimeout(function(){
        document.querySelector('[data-price-wrapper-sticky] [data-product-price]').innerHTML = document.querySelector('[data-main-product-form] [data-price-wrapper] [data-product-price]').innerHTML;
      }, 1000)
    } catch {
      console.log("price doesn't exist")
    }
}
function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}
document.addEventListener('DOMContentLoaded', function(){
  if (window.location.href.includes('sticky-atc=fixed-bottom')||window.location.href.includes('sticky-atc=bottom')||window.location.href.includes('sticky-atc=top')){
      document.querySelector('#sticky-atc').insertAdjacentHTML("afterend", '<style>.show-sticky{display: none;}</style>')
  }
})

if (window.location.href.includes('sticky-atc=fixed-bottom')){
    let productForm = document.querySelector('form[data-main-product-form]')
    if (isInViewport(productForm)){
        document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed')
        document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed-bottom')
    }
  }
var lastScrollTop = 0;
document.addEventListener("scroll", function(){ 
    let productForm = document.querySelector('form[data-main-product-form]')
   var st = window.pageYOffset || document.documentElement.scrollTop;
   if (st > lastScrollTop){
      if (window.location.href.includes('sticky-atc=top')){
        document.getElementById('sticky-atc').classList.remove('sticky-atc__position-fixed')
        document.getElementById('sticky-atc').classList.remove('sticky-atc__position-fixed-top')
      } else if (window.location.href.includes('sticky-atc=bottom')){
        document.getElementById('sticky-atc').classList.remove('sticky-atc__position-fixed')
        document.getElementById('sticky-atc').classList.remove('sticky-atc__position-fixed-bottom')
      } else if (window.location.href.includes('sticky-atc=fixed-bottom')){
        if (isInViewport(productForm)){
            document.getElementById('sticky-atc').classList.remove('sticky-atc__position-fixed')
            document.getElementById('sticky-atc').classList.remove('sticky-atc__position-fixed-bottom')
        } else{
            document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed')
            document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed-bottom')
        }
      }
   } else {
    if (window.location.href.includes('sticky-atc=top')){
        document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed')
        document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed-top')
      } else if (window.location.href.includes('sticky-atc=bottom')){
        document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed')
        document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed-bottom')
      } else if (window.location.href.includes('sticky-atc=fixed-bottom')){
        if (isInViewport(productForm)){
            document.getElementById('sticky-atc').classList.remove('sticky-atc__position-fixed')
            document.getElementById('sticky-atc').classList.remove('sticky-atc__position-fixed-bottom')
        } else{
            document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed')
            document.getElementById('sticky-atc').classList.add('sticky-atc__position-fixed-bottom')
        }
      }
   }
   lastScrollTop = st <= 0 ? 0 : st; 
}, false);